import { type Node, type NodeSpec } from "prosemirror-model";

export const readonly_section: NodeSpec = {
	group: "block",
	atom: true,
	selectable: false,
	draggable: false,
	attrs: {
		managedSection: { default: false },
		rawContent: { default: "" },
	},
	parseDOM: [
		{
			tag: "section[readonly]",
			getAttrs(node: string | HTMLElement) {
				if (typeof node === "string") {
					return {};
				}
				return {
					managedSection: node.getAttribute("data-variant") === "moment-agents-template",
					rawContent: node.innerHTML,
				};
			},
		},
	],
	toDOM(node: Node) {
		const domAttrs: Record<string, string> = {
			readonly: "",
			style: "display:none",
			contenteditable: "false",
		};
		if (node.attrs["managedSection"]) {
			domAttrs["data-variant"] = "moment-agents-template";
		}
		return ["section", domAttrs];
	},
};
